import React from 'react';
import {ISlideRenderer} from "../video-slides.service.interface";

export abstract class SlideBaseRenderer implements ISlideRenderer {
    constructor(public readonly uniqueKey: string) {

    }

    abstract render(): React.ReactElement;
}